/** @format */

export default {
    CONFIG: [
        {
            city: 'Las Vegas',
            stateCode: 'NV',
            countryCode: 'US',
            defaultNumberOfDays: 2,
        },
    ],
};
